import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-203ad1ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box"
};
const _hoisted_2 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-400px",
    "left": "-588px",
    "z-index": "2"
  }
}, null, -1));
const _hoisted_4 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-500px",
    "right": "-588px",
    "z-index": "1"
  }
}, null, -1));
const _hoisted_6 = {
  style: {
    "position": "relative",
    "z-index": "2"
  }
};
const _hoisted_7 = {
  style: {
    "position": "relative",
    "z-index": "2",
    "background": "linear-gradient(90deg, #f6f9fd 0%, #fff 100%)"
  }
};
const _hoisted_8 = {
  style: {
    "position": "relative",
    "z-index": "2",
    "background": "linear-gradient(90deg, #fff 0%, #f6f9fd 100%)"
  }
};
const _hoisted_9 = {
  style: {
    "position": "relative",
    "z-index": "2",
    "background": "linear-gradient(90deg, #f6f9fd 0%, #fff 100%)"
  }
};
const _hoisted_10 = {
  style: {
    "position": "relative",
    "z-index": "2",
    "background": "linear-gradient(90deg, #fff 0%, #f6f9fd 100%)"
  }
};
const _hoisted_11 = {
  style: {
    "position": "relative",
    "z-index": "2",
    "background": "linear-gradient(90deg, #f6f9fd 0%, #fff 100%)"
  }
};
const _hoisted_12 = {
  key: 0,
  style: {
    "position": "relative"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-100px",
    "left": "-688px",
    "z-index": "2"
  }
}, null, -1));
const _hoisted_14 = {
  key: 1,
  class: "universalRound-bg",
  style: {
    "background-position": "240% 100%",
    "background-size": "1800px 1600px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_com = _resolveComponent("header-com");
  const _component_bannar_com = _resolveComponent("bannar-com");
  const _component_agent_menu = _resolveComponent("agent-menu");
  const _component_safe_agent_com = _resolveComponent("safe-agent-com");
  const _component_code_agent_com = _resolveComponent("code-agent-com");
  const _component_safe_product_agent = _resolveComponent("safe-product-agent");
  const _component_aigc_com = _resolveComponent("aigc-com");
  const _component_model_to_com = _resolveComponent("model-to-com");
  const _component_detection_tool = _resolveComponent("detection-tool");
  const _component_number_com = _resolveComponent("number-com");
  const _component_product_navbar = _resolveComponent("product-navbar");
  const _component_bolg_list_com = _resolveComponent("bolg-list-com");
  const _component_apply_com = _resolveComponent("apply-com");
  const _component_footer_com = _resolveComponent("footer-com");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_header_com), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_bannar_com), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_agent_menu, {
    ref: "AgentMenu"
  }, null, 512)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_safe_agent_com, {
    ref: "safeAgentRef"
  }, null, 512)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_code_agent_com, {
    ref: "codeAgentRef"
  }, null, 512)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_safe_product_agent, {
    ref: "safeProductAgentRef"
  }, null, 512)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_aigc_com, {
    ref: "aigcRef"
  }, null, 512)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_model_to_com, {
    ref: "modelComRef"
  }, null, 512)]), false ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_detection_tool, {
    ref: "DetectionTool"
  }, null, 512), _hoisted_13])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_number_com, {
    ref: "NumberCom"
  }, null, 512), _createVNode(_component_product_navbar, {
    ref: "ProductNavbar"
  }, null, 512)])) : _createCommentVNode("", true), _createVNode(_component_bolg_list_com, {
    ref: "BolgListCom"
  }, null, 512), _createVNode(_component_apply_com, {
    ref: "ApplyComRef"
  }, null, 512), _createVNode(_component_footer_com)]);
}